import React from 'react';
import { SimpleShowLayout, Record, useTranslate, FileField } from 'react-admin';
import SectionTitle from '../SectionTitle';

import './styles.scss';

interface NutritionAdviceFoodJournalProps {
  record: Record | undefined;
}

// Test activation data for Health Check Basic in Nutrition Advice Show view
const NutritionAdviceFoodJournal: React.FC<NutritionAdviceFoodJournalProps> =
  () => {
    const translate = useTranslate();

    return (
      <SimpleShowLayout>
        <SectionTitle title={translate('nutritionAdviceFoodJournal.title')} />
        <FileField
          target="_blank"
          className="text--purple"
          source="steps.1.foodJournal.folderUrl"
          title={translate('nutritionAdviceFoodJournal.linkText') as string}
          label="nutritionAdviceFoodJournal.linkLabel"
        />
      </SimpleShowLayout>
    );
  };

export default NutritionAdviceFoodJournal;
